import { AxiosInstance } from 'axios';
import { HouseKeepingRootService } from 'services';

export interface HousekeepingReportServiceModel {
  getAll: ReturnType<typeof HouseKeepingRootService.getAll>;
  update: ReturnType<typeof HouseKeepingRootService.update>;
  reportIssue: ReturnType<typeof HouseKeepingRootService.reportIssue>;
}

export const initHousekeepingReportService = (
  axios: AxiosInstance
): HousekeepingReportServiceModel => ({
  getAll: HouseKeepingRootService.getAll(axios),
  update: HouseKeepingRootService.update(axios),
  reportIssue: HouseKeepingRootService.reportIssue(axios),
});
